import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const getNextBillingDate = createSelector(getData, (data) => {
  return get(data, "next_billing_date", null);
});
